export { default as MediaCollectionVideo } from './MediaCollectionVideo';
